import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, exhaustMap, filter, map, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { AxiosError } from 'axios'
import { RootEpic } from '../types'
import {
  getUserBankAccountsRequest,
  getUserBankAccountsSuccess,
  getUserBankAccountsFailure,
  updateUserBankAccountStatusRequest,
  updateUserBankAccountStatusSuccess,
  updateUserBankAccountStatusFailure,
} from '../actions'

export const getUserBankAccountsEpic: RootEpic = (action$, state$, { getUserBankAccounts }) => {
  return action$.pipe(
    filter(isActionOf([getUserBankAccountsRequest])),
    switchMap(({ payload }) =>
      from(
        getUserBankAccounts({
          token: state$.value.app.authToken as string,
          ...payload,
          limit: 10,
        }),
      ).pipe(
        map((response) => getUserBankAccountsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch bank accounts.')
          return of(getUserBankAccountsFailure(message))
        }),
      ),
    ),
  )
}

export const updateUserBankAccountStatusEpic: RootEpic = (action$, state$, { updateUserBankAccountStatus }) => {
  return action$.pipe(
    filter(isActionOf([updateUserBankAccountStatusRequest])),
    exhaustMap(({ payload }) =>
      from(
        updateUserBankAccountStatus({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => {
          toast.success('User bank account status was successfully updated.')
          return updateUserBankAccountStatusSuccess(response)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to update user bank account status.')
          return of(updateUserBankAccountStatusFailure(error))
        }),
      ),
    ),
  )
}

export default [getUserBankAccountsEpic, updateUserBankAccountStatusEpic]
